import { Outlet } from 'react-router-dom';
import menUrl from './imgs/men.png';
import sneakersUrl from './imgs/sn.png';
import hatsUrl from './imgs/h.png';
import jacketsUrl from './imgs/ja.png';
import womenUrl from './imgs/aa.png';

import Directory from '../../components/directory/directory.component';

const Home = () => {
  const categories = [
    {
      id: 1,
      title: 'HATS',
      imageUrl: hatsUrl,
    },
    {
      id: 2,
      title: 'JACKETS',
      imageUrl: jacketsUrl,
    },
    {
      id: 3,
      title: 'SNEAKERS',
      imageUrl: sneakersUrl,
    },
    {
      id: 4,
      title: 'WOMEN',
      imageUrl: womenUrl,
    },
    {
      id: 5,
      title: 'MEN',
      imageUrl:menUrl,
    },
  ];

  return (
    <div>
      <Directory categories={categories} />
      <Outlet />
    </div>
  );
};

export default Home;
